import React from 'react';
import Services from '../components/Services';
import SEO from '../components/SEO';
import './Services.css';

const ServicesPage = () => {
    const structuredData = {
        '@context': 'https://schema.org',
        '@type': 'Service',
        serviceType: 'E-commerce and Digital Marketing Services',
        provider: {
            '@type': 'Organization',
            name: 'Avenis Global',
            url: 'https://avenisglobal.com',
        },
        areaServed: 'United States',
        hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'Avenis Global Services',
            itemListElement: [
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'Amazon Wholesale',
                        description:
                            'Comprehensive Amazon wholesale solutions and partnerships',
                    },
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'Brand Partnerships',
                        description:
                            'Strategic brand partnerships and collaborations',
                    },
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'E-commerce Consulting',
                        description:
                            'Expert e-commerce consulting and strategy development',
                    },
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'Digital Marketing',
                        description:
                            'Comprehensive digital marketing solutions',
                    },
                },
            ],
        },
    };

    return (
        <div className="services-page">
            <SEO
                title="Services"
                description="Discover our comprehensive e-commerce and digital marketing services including Amazon wholesale, brand partnerships, e-commerce consulting, and digital marketing solutions."
                keywords="Amazon wholesale services, brand partnerships, e-commerce consulting, digital marketing services, wholesale solutions, Amazon seller services"
                url="https://avenisglobal.com/services"
                structuredData={structuredData}
            />
            <div className="services-hero">
                <div className="container">
                    <h1>Our Services</h1>
                    <p>
                        Comprehensive e-commerce solutions designed to scale
                        your business with MAP compliance, brand partnerships,
                        and wholesale excellence.
                    </p>
                </div>
            </div>
            <Services />
        </div>
    );
};

export default ServicesPage;
